declare const I18n;

import React from "react";

type AchievementTabsProps = {
  currentTab: string;
  setCurrentTab: (tab: string) => void;
};

const AchievementTabs: React.FC<AchievementTabsProps> = ({ currentTab, setCurrentTab }) => {
  return (
    <ul className="nav nav-tabs" style={{ paddingBottom: 0 }}>
      <li className="nav-item">
        <button
          className={`nav-link ${currentTab === "badge" ? "active" : ""}`}
          onClick={() => setCurrentTab("badge")}
        >
          {I18n.t("views.achievements.common.badges")}
        </button>
      </li>

      <li className="nav-item">
        <button
          className={`nav-link ${currentTab === "ranks" ? "active" : ""}`}
          onClick={() => setCurrentTab("ranks")}
        >
          {I18n.t("views.achievements.common.ranks")}
        </button>
      </li>
    </ul>
  );
};

export default AchievementTabs;
